import React from 'react';
import { FadeIn } from './FadeIn';
import { QuoteIcon } from 'lucide-react';
export function Proof() {
  return <section className="py-24 bg-white" data-id="element-221">
      <div className="container mx-auto px-4" data-id="element-222">
        <div className="max-w-4xl mx-auto" data-id="element-223">
          <FadeIn data-id="element-224">
            <div className="relative p-8 md:p-16 bg-parchment/30 rounded-3xl border border-gold/20 text-center" data-id="element-225">
              <QuoteIcon className="absolute top-8 left-8 w-12 h-12 text-gold/20 rotate-180" data-id="element-226" />
              <QuoteIcon className="absolute bottom-8 right-8 w-12 h-12 text-gold/20" data-id="element-227" />

              <h2 className="text-2xl md:text-3xl font-serif text-navy font-bold leading-relaxed relative z-10" data-id="element-228">
                En solo{' '}
                <span className="text-gold underline decoration-gold/50 underline-offset-4" data-id="element-229">
                  7 días
                </span>{' '}
                de aplicar el Protocolo 2:2, tu mente pasará del estado de
                "alerta por supervivencia" a un estado de "expectativa de
                victoria"...
              </h2>

              <p className="mt-8 text-lg text-charcoal max-w-2xl mx-auto relative z-10" data-id="element-230">
                ...permitiéndote ver oportunidades de negocio y suministro que
                siempre estuvieron ahí, pero que tu miedo no te dejaba ver.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}